import axios from 'axios'
import WPAPI from 'wpapi'

export const baseURL = process.env.NEXT_PUBLIC_WP_BASE_URL

export const wpapi = new WPAPI({ endpoint: `${baseURL}/wp-json` })

const api = axios.create({
    baseURL: baseURL + '/wp-json/',
})

export { api }

export const blogAPI = axios.create({
    baseURL: 'https://blog.openlettermarketing.com/' + '/wp-json/',
})

const authAPI = axios.create({
    baseURL: baseURL + '?rest_route=/simple-jwt-login/v1/',
})

export { authAPI }

const nextAPI = axios.create({
    baseURL: '/api',
    withCredentials: true,
})

nextAPI.defaults.withCredentials = true

// nextAPI.interceptors.request.use(async (config) => {
//     const { cookie } = await axios.get('/api/handle-woo', {
//         withCredentials: true,
//         credentials: 'include',
//     })
//     if(cookie){
//         config.headers.Cookie = cookie
//     }
//     return config
//   }, function (error) {
//     // Do something with request error
//     console.log('error', error)
//   })

export { nextAPI }

const ecomAPI = axios.create({
    baseURL: '/api/ecom/',
})

export { ecomAPI }

const proofAPI = axios.create({
    baseURL: '/api/proofs/',
})

export { proofAPI }
